import {
  IRootWidget,
  IWidgetType,
  TreeNavigatorLogic,
  WidgetRepository,
  WidgetSelect,
  WidgetType,
} from '@framework/engine';
import produce from 'immer';
import React from 'react';
import styled from 'styled-components';

export interface IAddWidgetSelectInputProps {
  root: IRootWidget;
  setRoot: React.Dispatch<React.SetStateAction<IRootWidget>>;
  filter?: (widget: IWidgetType<any>) => boolean;
}

const AddWidgetWrapper = styled.div`
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80px;
  margin: -8px;
  margin-top: 8px;
  border: 2px solid ${props => props.theme.colorPrimaryBg};
  background-color: ${props => props.theme.colorPrimaryBg};
  border-radius: 8px;
`;

/**
 * Select per aggiungere un nuovo widget in coda alla root
 */
export function AddWidgetSelectInput(props: IAddWidgetSelectInputProps) {
  const { root, setRoot } = props;

  return (
    <AddWidgetWrapper>
      <WidgetSelect
        style={{ width: '100%', maxWidth: '400px' }}
        placeholder="Aggiungi un elemento"
        filter={props.filter}
        // Il value è null perché il componente non seleziona davvero un widget
        // ma è utilizzato unicamente come supporto grafico alla funzione di onChange
        value={null}
        // Aggiungo un nuovo elemento alla root
        onChange={(value: WidgetType) => {
          if (root == null) return;
          // Genero un widget "vuoto" del tipo richiesto
          const widget = WidgetRepository.getInitial(value);

          if (!widget) return;

          // Imposto la nuova root
          setRoot(
            produce((root: IRootWidget) => {
              // Aggiungo il widget in coda alla root
              root.children.push(widget);
              // Ricalcolo l'ordine dell'albero
              TreeNavigatorLogic.computeOrder(root);
            }),
          );
        }}
      />
    </AddWidgetWrapper>
  );
}
